export const FEEDBACK_TYPE_OPTIONS = [{
  // locale key for the label
  label: 'bug',
  // To work well with slack integration it has to be exact match with Task board column in https://tokyotechies.slack.com/lists/T6NN2NW5B/F0793K6A6E7
  value: 'Bug'
},
{
  label: 'painPoint',
  value: 'Pain Point'
},
{
  label: 'idea',
  value: 'Idea'
},
{
  label: 'other',
  value: 'Other'
}]